import { ReactFlowInstance, Node } from "@xyflow/react";
import {RJSFSchema} from "@rjsf/utils";

/**
 * Delete workflow node and all child nodes and edges
 * @param context
 * @param reactFlowInstance
 */
export function processNodeDelete(context: any, reactFlowInstance: ReactFlowInstance): void {
    let nodes: Node[] = context.nodes;
    let newNodes: Node[] = [];
    let deleteNodes: Node[] = [];
    for (const node of nodes) {
        if (!node.id.includes(context.activeSampleDataNode.id)) {
            newNodes.push(node);
        } else {
            deleteNodes.push(node);
            // reactFlowInstance.deleteElements(node.id);
        }
    }

    let edges = context.edges;
    let removeEdges = [];
    let newEdges = [];
    for (const edge of edges) {
        if (edge.id.includes(context.activeSampleDataNode.id)) {
            removeEdges.push(edge);
            // reactFlowInstance.deleteElements(edge.id);
        } else {
            newEdges.push(edge);
        }
    }
    // reactFlowInstance.setEdges(newEdges);
    // reactFlowInstance.setNodes(newNodes);

    context.updateLayoutNodes(newNodes);
    context.updateLayoutEdges(newEdges);
}


export function processNodeFormSubmit(context: any, formData: any, reactFlowInstance: ReactFlowInstance): void {
    // debugger;
    let editNode = context.activeSampleDataNode;
    if (editNode === undefined) {
        return;
    }
    editNode.data = formData;

    let allNodes = reactFlowInstance.getNodes();
    let newNodes = [];
    let activeIds = [];
    for (const node of allNodes) {
        if (!activeIds.includes(node.id)) {
            activeIds.push(node.id);
            newNodes.push(node);
        }
    }

    let updatedNodes = [editNode];
    for (const node of newNodes) {
        if (node.id !== editNode.id) {
            updatedNodes.push(node);
        }
    }
    ;
    reactFlowInstance.updateNodeData(editNode.id, formData);
    context.updateLayoutNodes(updatedNodes);

}

export const formSchema: RJSFSchema = {
    title: '',
    type: 'object',
    required: [],
    properties: {
        // CREATE CUSTOM ERROR STATE FOR LOCATION
       sample_type: {
            title: 'Sample Data Type',
            type: 'string',
            enum: [
                'Text',
                'Number',
                'Array',
                'Key/Value Array',
                'True/False',
                'Data Model'
            ],
           default: 'Text'
       },
        data_management: {
           title: 'Data Store',
            type: 'string',
            description: 'Location to store Sample Data',
            default: 'default'
        }
    },
    allOf: [
        {
            if: {
                properties: {
                    sample_type: {
                        const: 'Text'
                    }
                }
            },
            then: {
                properties: {
                    sample_text: {
                        title: 'Sample Text',
                        type: 'string',
                        description: 'Sample Text',
                        default: ''
                    }
                }
            }
        },
        {
            if: {
                properties: {
                    sample_type: {
                        const: 'Number'
                    }
                }
            },
            then: {
                properties: {
                    sample_number: {
                        title: 'Sample Number',
                        type: 'number',
                        description: 'Sample Number',
                    }
                }
            }
        },
        {
            if: {
                properties: {
                    sample_type: {
                        const: 'True/False'
                    }
                }
            },
            then: {
                properties: {
                    sample_true_false: {
                        title: 'Sample True/False',
                        type: 'string',
                        enum: [
                            'True',
                            'False',
                        ],
                        default: 'True',
                        description: 'Sample True/False',
                    }
                }
            }
        },
        {
            if: {
                properties: {
                    sample_type: {
                        const: 'Array'
                    }
                }
            },
            then: {
                properties: {
                    sample_array: {
                        title: 'Sample Array',
                        type: 'string',
                        description: 'Add comma separated values.',
                    }
                }
            }
        },
        {
            if: {
                properties: {
                    sample_type: {
                        const: 'Key/Value Array'
                    }
                }
            },
            then: {
                properties: {
                    sample_key_value_array: {
                        title: 'Sample Key/Value Array',
                        type: 'string',
                        description: 'Add JSON to be converted to key/value array',
                    }
                }
            }
        },
        {
            if: {
                properties: {
                    sample_type: {
                        const: 'Data Model'
                    }
                }
            },
            then: {
                properties: {
                    sample_data_model: {
                        title: 'Sample Data Model Structure JSON',
                        type: 'string',
                        description: 'Sample Data Model',
                    },
                    sample_data_model_value: {
                        title: 'Sample Data Model Data JSON',
                        type: 'string'
                    }
                }
            }
        }
    ]
}

export const nodeDescription: string = "This node is used to manually add sample data to a Data Slot for testing purposes.\n";

